import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { SupplierList } from "./supplierList"

export const SupplierListLoader = () => (
    <ListLoaderWrapper table={TableName.SUPPLIERS}>
        <SupplierList />
    </ListLoaderWrapper>
)
